import './header-over-media.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

// Zolang een full-bleed foto-sectie ([data-header-over-media]) onder de
// menubalk zit, krijgt body .is-header-over-media: geen frosted balk en een
// wit menu (de slider in Figma 3583:7360 heeft geen balk; de teller zit op 42
// en viel anders weg achter de balk).
function initHeaderOverMedia() {
	document.querySelectorAll( '[data-header-over-media]' ).forEach( ( section ) => {
		ScrollTrigger.create( {
			trigger: section,
			start: 'top 40px',
			end: 'bottom 40px',
			onToggle: ( self ) => {
				document.body.classList.toggle( 'is-header-over-media', self.isActive );
			},
		} );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initHeaderOverMedia );
} else {
	initHeaderOverMedia();
}
